/**
 * Segment analytics for the theme, mirroring the headless site's behavior:
 * - analytics.js loads ONLY when a write key is configured in theme settings
 *   (empty in the parallel build so preview traffic never reaches production data)
 *   AND analytics processing is allowed by Shopify's Customer Privacy API.
 * - A source middleware merges stored attribution into context.campaign on every
 *   event (existing fields win), matching campaignSourceMiddleware on the site.
 * - Events: Page on load; Product Viewed on the PDP; Product Added and Cart Viewed
 *   are fired from shop.js / the cart page via window.LBAnalytics.track.
 *   Checkout funnel events keep coming from the store-level web pixel.
 */
window.LBAnalytics = (() => {
  const cfg = window.LBAnalyticsConfig || {};
  const writeKey = (cfg.segmentWriteKey || '').trim();

  const analyticsAllowed = () => {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return true;
    return cp.analyticsProcessingAllowed() !== false;
  };

  const enabled = () => !!writeKey && analyticsAllowed();

  const loadSnippet = () => {
    if (window.analytics && window.analytics.initialize) return;
    // Segment analytics.js snippet (4.15-style), minimal form.
    const analytics = (window.analytics = window.analytics || []);
    if (analytics.invoked) return;
    analytics.invoked = true;
    analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware'];
    analytics.factory = function (method) {
      return function () {
        const args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        analytics.push(args);
        return analytics;
      };
    };
    for (const method of analytics.methods) analytics[method] = analytics.factory(method);
    analytics.load = function (key, options) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
      const first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
      analytics._loadOptions = options;
    };
    analytics._writeKey = writeKey;
    analytics.SNIPPET_VERSION = '4.15.3';

    // Parity with campaignSourceMiddleware: stored attribution rides every event's context.campaign.
    analytics.addSourceMiddleware(({ payload, next }) => {
      try {
        const stored = window.LBAttribution && window.LBAttribution.getStoredAttribution();
        if (stored) {
          payload.obj.context = payload.obj.context || {};
          payload.obj.context.campaign = Object.assign({}, stored, payload.obj.context.campaign);
        }
      } catch { /* attribution is best-effort */ }
      next(payload);
    });

    analytics.load(writeKey);
    analytics.page();
  };

  const track = (event, properties) => {
    if (!enabled() || !window.analytics) return;
    try { window.analytics.track(event, properties); } catch { /* never break the storefront */ }
  };

  if (enabled()) loadSnippet();

  return { track, enabled };
})();

 document.addEventListener('click', event => {
   const element = event.target.closest('[data-element-name]');
   if (element) window.LBAnalytics?.track(element.tagName === 'A' ? 'Link Pressed' : 'Button Pressed', {element_name: element.dataset.elementName});
 });
